import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import {
  getClientById,
  getKwestionariushByClientId,
} from "../service/weexpertService";
import { useQuery } from "react-query";
import { Loader } from "@/components/ProtectedRoute";
import { Button } from "@/components/ui/button";
import { KwestionariushView } from "@/components/clients/kwestionariush.view";

export const ClientKwestionariushViewPage = () => {
  const { t } = useTranslation();
  const { clientId, kwestionariushId } = useParams();

  const { data: client, isLoading } = useQuery({
    queryKey: ["client", clientId],
    queryFn: () => {
      return getClientById(clientId);
    },
  });

  const { data: kwestionariush, isKwestionariushLoading } = useQuery({
    queryKey: ["kwestionariush", clientId],
    queryFn: () => {
      return getKwestionariushByClientId(clientId);
    },
  });

  if (isLoading) {
    return <Loader />;
  }

  if (isKwestionariushLoading || !kwestionariush || !kwestionariush.data) {
    return <Loader />;
  }

  return (
    <div className="relative bg-grayLightMainBg px-8">
      <div className="sticky left-0 top-16 z-10 w-full bg-grayLightMainBg">
        <div className="flex justify-between py-8 items-center">
          <div className="w-5/12 text-4xl">Kwestionariusz</div>
          <div className="flex justify-end">
            <Link to={`/admin/client/details/${client.data.id}`}>
              <Button className="min-w-20">{t("button_back")}</Button>
            </Link>
          </div>
        </div>
      </div>
      <div className="w-full pt-2 pb-6">
        <div className="text-2xl">
          {client.data && client.data.firstName + " " + client.data.lastName}
        </div>
      </div>
      <div>
        <KwestionariushView kwestionariush={kwestionariush.data} />
      </div>
    </div>
  );
};